import React, { useEffect,useState } from "react";
import { useSelector, shallowEqual,useDispatch } from "react-redux";
import { fetchSearchResultData } from '../actions/action';
import ListingViewCell from '../../../components/CardListing/listingViewCell';
import CardView from "../../../components/CardListing/cardView";
import ListingComponent from "../../../components/ListingComponent";
import { getUserInfo } from "../../SpockViewPage/actions/action";
import EmptyScreen from '../../../Emptyscreen';
import * as CommonUtil from '../../../common/util';
import {WorkkardListingLoader,WorkkardListingHeaderLoader,CardListingMobileLoader} from '../../../components/SkeletonLoader';
import LoaderComponent from '../../../components/Loader';
import { useModules } from '../../../utils/modules';

const Workkards = (props) => {
    const { isModuleEnabled } = useModules();
    const { globalSearch } = useSelector(state => ({
        globalSearch: state.header.globalSearch
    }), shallowEqual);

    const dispatch=useDispatch();

    const dataPayload={
        skip: 0,
        take: 100,
        isSearch: true,
        sortDir: 'ASC',
        sortBy: 1,
        rows: 100,
        displayCount: 100,
        status: 'workkards',
        _: new Date()

    };
    const [mode, updateMode] = useState({isLandscape:false});
    const showCarrierClaim = isModuleEnabled("top_bar_search.prefetch") &&
        process.env.topbar_search_org_ids.split(",").includes(String(props.organizationId));

    useEffect(() => {
        if(CommonUtil.mobileAndTabletcheck() && window.innerHeight < window.innerWidth){
            updateMode({isLandscape:true})
        }   
      }, []);

    const openMiniProfile = (payload) => {
        dispatch(getUserInfo(payload));
    }
    const renderListing=()=>{
        const {Data}=globalSearch.workkards;
        if(Data.length >0)
        {
            if(!mode.isLandscape && CommonUtil.mobileAndTabletcheck()){
                return <CardView type={"WORKKARD"} data={{WorkkardsFullData:Data}}  onScrollHandler={onScrollHandler} globalSearch={globalSearch.activeTab} />;    
            }
            const prop = {
                data: Data,
                cellTemplate: ListingViewCell,
                onScrollHandler: onScrollHandler,
                onItemClick:false,
                onCellClick:openMiniProfile,
                type:"div",
                selectedId: '',
                classname: 'scrollArea',
                isPagination:false,
                extraData:{selectedids:"",listType:"WORKKARD",showCheckbox:false,globalSearch : globalSearch.activeTab, showCarrierClaim: showCarrierClaim}
            }
            return (
                <React.Fragment>
                    <ListingComponent {...prop}/>
                </React.Fragment>
            );
        }
        else{
            return <EmptyScreen name="Emptyworkkard" type={"workkard"} />;
        }
    }

    const onScrollHandler = () => {
        const { skip, take,Total} = globalSearch.workkards;
        const payload={
            ...dataPayload
        };
        payload.key = props.searchString;
        payload.take = (skip === 0 && take > 20 ) ? 20 : parseInt(take);
        payload.skip = (skip === 0 && take > 20 ) ? take : parseInt(skip)+parseInt(take);
        payload.rows = (skip === 0 && take > 20 ) ? 20 : parseInt(take);
        payload.isUpdate = true;
        if(skip+take < Total){
            dispatch(fetchSearchResultData(payload));
        }
    }

    return (
        <React.Fragment>
            {
                (globalSearch.isLoading && globalSearch.workkards.Data.length ==0 && !props.showResult) ?
                (
                    !mode.isLandscape && CommonUtil.mobileAndTabletcheck()?
                    <CardListingMobileLoader count={2}/>
                    :
                    <React.Fragment>
                        <WorkkardListingHeaderLoader/>
                        <WorkkardListingLoader count={4} />  
                        <div className="blankDiv"></div>  
                    </React.Fragment>
                )                   
                :
                <div className={`${!mode.isLandscape && CommonUtil.mobileAndTabletcheck() ? '' : 'table'} cardListView scrollArea`}>
                    {
                        globalSearch.isLoading && !props.showResult && <LoaderComponent/>
                    }
                    {
                        (globalSearch.workkards.Data.length >0 && !mode.isLandscape && !CommonUtil.mobileAndTabletcheck())
                        ?
                        <div className="rowFlex tableHead">
                            <ul>
                                <li>Workkard Number</li>
                                 {showCarrierClaim && <li className="">Carrier Claim Number</li> }
                                <li className="">Workkard Info</li>
                                <li>{showCarrierClaim ? 'Workkard Title' :  'Description'}</li>
                                <li className="">Workkard Owner</li>
                                <li className="">Carrier</li>
                            </ul>
                        </div>
                        :
                        (mode.isLandscape && globalSearch.workkards.Data.length >0) && 
                        <div className="rowFlex tableHead">
                            <ul>
                            <li>Workkard Number</li>
                                 {showCarrierClaim && <li className="">Carrier Claim Number</li> }
                                <li className="">Workkard Info</li>
                                <li>{showCarrierClaim ? 'Workkard Title' :  'Description'}</li>
                                <li className="">Workkard Owner</li>
                                <li className="">Carrier</li>
                            </ul>
                        </div>
                    }
                    <div className={`rowFlex tableBody ${globalSearch.workkards.Data.length ==0 ? `noDataFound`:''}`}>
                        <div>
                            {
                                globalSearch.workkards.status != null &&
                                (
                                    globalSearch.workkards.status != 200 ?
                                    <EmptyScreen name="Errorscreen" onRefreshClick={()=>dispatch(fetchSearchResultData(Object.assign({},dataPayload,{key:props.searchString})))}/>
                                    :
                                    globalSearch.activeTab==0 && renderListing()
                                )
                            }
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}
export default Workkards;
